module.exports = __webpack_public_path__ + "static/media/red-timer.9151112e.png";